import React, { Component } from 'react';
import MOBILE_CLASSES from './mobileStylesClasses';
import { withTranslation } from 'react-i18next';
import DayCell from './dayCell';
import moment from 'moment';
import _ from 'lodash';
import { MomentFormats } from '../../../utils';
import { getWeekStart, getWeekEnd } from '../Utils/momentHelper';

class MonthlyView extends Component {
    renderCalendarHeader() {
        const { classes = MOBILE_CLASSES, t, firstDayOfTheWeek } = this.props;
        const daysOfWeek = [t('days.short.sunday'), t('days.short.monday'), t('days.short.tuesday'), t('days.short.wednesday'), t('days.short.thursday'), t('days.short.friday'), t('days.short.saturday')];

        let headers = [];
        for (let i = 0; i < 7; i++) {
            headers.push(<div className={classes.calendarHeaderField}>{daysOfWeek[(i + firstDayOfTheWeek) % 7]}</div>);
        }

        return <div className={classes.calendarHeader}>
            {headers}
        </div>;
    }

    generateDotClasses(day, employeeShifts, employeePaycodes, classes) {
        let dotClasses = [];
        let index = moment.utc(day).format(MomentFormats.YYMMDD);

        if (employeeShifts[index]) {
            dotClasses.push(classes.shiftsDot);
        }

        if (employeePaycodes[index]) {
            dotClasses.push(classes.paycodesDot);
        }

        return dotClasses;
    }

    generateBoxClasses(day, toCoverOffers, myToCoverRequests, myToCoverOffers, mySwapOffers, availableShiftOffers, myProposals, availableOpenShifts, myOpenShiftRequests, availableVTO, myVTORequests, classes) {
        let boxClasses = [];
        let index = moment.utc(day).format(MomentFormats.YYMMDD);

        let nbMyRequests = 0;
        if (myToCoverOffers[index]) {
            nbMyRequests += myToCoverOffers[index].length;
        }

        if (myToCoverRequests[index]) {
            nbMyRequests += myToCoverRequests[index].length;
        }

        if (mySwapOffers[index]) {
            nbMyRequests += mySwapOffers[index].length;
        }

        if (myProposals[index]) {
            const uniqueOfferIdReqs = _.uniqBy(myProposals[index], 'offerId')
            nbMyRequests += uniqueOfferIdReqs.length;
        }

        if (myOpenShiftRequests[index]) {
            nbMyRequests += myOpenShiftRequests[index].length;
        }

        if (myVTORequests[index]) {
            nbMyRequests += myVTORequests[index].length;
        }

        if (nbMyRequests) {
            boxClasses.push({ class: classes.dayCellBox_MINE, value: nbMyRequests })
        }

        if (toCoverOffers[index]) {
            boxClasses.push({ class: classes.dayCellBox_TC, value: toCoverOffers[index].length >= 3 ? '3+' : toCoverOffers[index].length })
        }

        if (availableShiftOffers[index]) {
            boxClasses.push({ class: classes.dayCellBox_SS, value: availableShiftOffers[index].length })
        }

        if (availableOpenShifts[index]) {
            boxClasses.push({ class: classes.dayCellBox_OS, value: availableOpenShifts[index].length })
        }

        if (availableVTO[index]) {
            boxClasses.push({ class: classes.dayCellBox_VTO, value: availableVTO[index].length })
        }

        return boxClasses;
    }

    renderWeek(weekIndex, viewingMonth, firstDayOfTheWeek) {
        const { classes = MOBILE_CLASSES, employeeShifts, employeePaycodes, toCoverOffers, myToCoverRequests, myToCoverOffers, mySwapOffers, availableShiftOffers, myProposals, availableOpenShifts, myOpenShiftRequests, availableVTO, myVTORequests, onDayClick } = this.props;

        let content = [];

        let startOfMonth = moment.utc(viewingMonth).startOf('month');
        let startOfFirstWeek = getWeekStart(startOfMonth, firstDayOfTheWeek);
        
        for (let i = 0; i < 7; i++) {
            let currentDate = startOfFirstWeek.clone().add(weekIndex * 7 + i, 'days');
            let isCurrentMonth = currentDate.isSame(viewingMonth, 'month');

            let today = currentDate.valueOf();
            let dotClasses = this.generateDotClasses(today, employeeShifts, employeePaycodes, classes);
            let boxClasses = this.generateBoxClasses(today, toCoverOffers, myToCoverRequests, myToCoverOffers, mySwapOffers, availableShiftOffers, myProposals, availableOpenShifts, myOpenShiftRequests, availableVTO, myVTORequests, classes);

            content.push(<DayCell
                empty={false}
                dayValue={currentDate.date()}
                dotClasses={dotClasses}
                boxClasses={boxClasses}
                isCurrentMonth={isCurrentMonth}
                onClick={() => onDayClick(currentDate)}
            />);
        }

        return <div className={classes.calendarRow}>{content}</div>
    }

    renderCalendar() {
        let { currentMonth, firstDayOfTheWeek } = this.props;
        var viewingMonth = moment.utc(currentMonth);

        let startOfMonth = viewingMonth.clone().startOf('month');
        let endOfMonth = viewingMonth.clone().endOf('month');
        let startOfFirstWeek = getWeekStart(startOfMonth, firstDayOfTheWeek);
        let endOfLastWeek = getWeekEnd(endOfMonth, firstDayOfTheWeek);
        let totalWeeks = endOfLastWeek.diff(startOfFirstWeek, 'weeks') + 1;
        
        let content = [];
        for (let weekIndex = 0; weekIndex < totalWeeks; weekIndex++) {
            content.push(this.renderWeek(weekIndex, viewingMonth, firstDayOfTheWeek));
        }

        return <div>{content}</div>;
    }

    render() {

        return (
            <React.Fragment>
                {
                    this.renderCalendarHeader()
                }
                {
                    this.renderCalendar()
                }
            </React.Fragment>
        );
    }
}

export default withTranslation('employmentBillboard')(MonthlyView);
